import { FeaturesComponentData } from "../FeaturesData"
const limitDefault = 6;
export const injectSharedComponent = function(data:FeaturesComponentData,overrides:FeaturesComponentData):FeaturesComponentData{
    return {
        ...data,
        ...overrides
    }}